import { slideToggle, slideUp } from '~/js/helpers';

export function initDetailsAnimation(container = document, allOpen = false) {
	const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const details = container.querySelectorAll('details');

	details.forEach((detail) => {
		const summary = detail.querySelector('summary');
		const content = detail.querySelector('[data-content]');
		if (!content) {
			return;
		}
		summary.addEventListener('click', function (e) {
			e.preventDefault();
			if (detail.hasAttribute('open')) {
				setTimeout(() => detail.removeAttribute('open'), 300);
			} else {
				detail.setAttribute('open', '');
			}
			!prefersReduced ? slideToggle(content) : content.classList.toggle('hidden');

			// Close all other details
			if (!allOpen) {
				const siblings = detail.parentNode.querySelectorAll('details');
				siblings.forEach((sibling) => {
					if (!sibling.contains(e.target) && sibling.querySelector('[data-content]')) {
						!prefersReduced
							? slideUp(sibling.querySelector('[data-content]'))
							: sibling.querySelector('[data-content]').classList.add('hidden');
						setTimeout(() => sibling.removeAttribute('open'), 300);
					}
				});
			}
		});
	});

	document.addEventListener('facetwp-loaded', function () {
		const toggles = document.querySelectorAll('.facetwp-toggle');
		toggles.forEach((toggle) => {});
	});
}
